import styles from "./AGB.module.css";

function AGB() {
  return (
    <div className={styles.agbContainer}>
      {/* Hauptüberschrift für die AGB-Seite */}
      <h1>Allgemeine Geschäftsbedingungen (AGB)</h1>

      {/* Hinweis zum Widerrufsrecht (aktuell noch ohne Inhalt) */}
      <h2> Widerrufsrecht</h2>

      {/* Abschnitt 1: Geltungsbereich der AGB */}
      <h2>1. Geltungsbereich</h2>
      <p>
        Diese Allgemeinen Geschäftsbedingungen (AGB) gelten für alle Verträge
        zwischen der <strong>Gagos GbR</strong>, Oskar-Meixner-Str. 4, 68163
        Mannheim (nachfolgend „Gagos" oder „wir" genannt) und ihren Kunden im
        Bereich Catering sowie für den Verkauf von Speisen und Getränken an
        unseren Foodtruck-Standorten.
      </p>
      <p>Die AGB unterscheiden zwischen:</p>
      <ul>
        <li>
          <strong>Catering-Dienstleistungen</strong>, die nur per E-Mail gebucht
          werden können und einer gesonderten vertraglichen Vereinbarung
          unterliegen.
        </li>
        <li>
          <strong>Direktverkauf an unseren Foodtrucks</strong>, bei dem die AGB
          nur in Bezug auf den Verkauf und Konsum von Speisen und Getränken vor
          Ort Anwendung finden.
        </li>
      </ul>

      {/* Abschnitt 2: Wie Catering-Verträge zustande kommen */}
      <h2>2. Vertragsschluss für Catering-Dienstleistungen</h2>
      <ol>
        <li>
          Die Buchung von Catering-Dienstleistungen erfolgt ausschließlich per
          E-Mail.
        </li>
        <li>
          Mit der Annahme des Angebots durch den Kunden kommt ein verbindlicher
          Vertrag zustande.
        </li>
        <li>
          Alle Vereinbarungen zu Leistungen, Mengen, Preisen, Lieferzeiten und
          Zahlungsmodalitäten werden individuell im Vertrag geregelt.
        </li>
        <li>
          Änderungen oder Sonderwünsche sind nur nach schriftlicher Bestätigung
          durch Gagos möglich.
        </li>
      </ol>

      {/* Abschnitt 3: Regeln für Stornierungen und Rücktritt */}
      <h2>3. Stornierung und Rücktritt bei Catering-Buchungen</h2>
      <ol>
        <li>Stornierungen sind schriftlich per E-Mail mitzuteilen.</li>
        <li>Je nach Zeitpunkt der Stornierung fallen folgende Gebühren an:</li>
      </ol>
      <div>
        <ul>
          <li>
            Bis <strong>14 Tage vor dem Event</strong>: Kostenfreie Stornierung
          </li>
          <li>
            <strong>13 bis 7 Tage vor dem Event</strong>: 50 % des Auftragswerts
          </li>
          <li>
            <strong>Weniger als 7 Tage vor dem Event</strong>: 100 % des
            Auftragswerts
          </li>
        </ul>
      </div>
      <ol start="3">
        <li>
          Sollte das Event aufgrund höherer Gewalt nicht stattfinden können (z.
          B. behördliche Anordnungen, Naturkatastrophen), kann eine Umbuchung
          vereinbart werden.
        </li>
      </ol>

      {/* Abschnitt 4: Verkauf direkt an Foodtrucks */}
      <h2>4. Verkauf an den Foodtrucks</h2>
      <ol>
        <li>
          Der Kauf von Speisen und Getränken an unseren Foodtrucks erfolgt
          direkt vor Ort gegen Barzahlung oder Kartenzahlung.
        </li>
        <li>
          Es besteht kein Anspruch auf Rückgabe oder Umtausch gekaufter Speisen
          und Getränke, es sei denn, es liegt ein Mangel vor.
        </li>
      </ol>

      {/* Abschnitt 5: Liefer- und Leistungsbedingungen */}
      <h2>5. Liefer- und Leistungsbedingungen für Catering</h2>
      <ol>
        <li>
          Die Lieferung erfolgt zum vereinbarten Zeitpunkt an die vom Kunden
          angegebene Adresse.
        </li>
        <li>
          Verzögerungen durch unvorhersehbare Umstände (z. B.
          Verkehrsbehinderungen) berechtigen nicht zu Schadensersatzansprüchen.
        </li>
      </ol>

      {/* Abschnitt 6: Haftungsregelungen */}
      <h2>6. Haftung</h2>
      <ol>
        <li>
          Gagos haftet für Schäden nur bei Vorsatz oder grober Fahrlässigkeit.
        </li>
        <li>
          Bei berechtigten Mängeln im Catering sind diese unverzüglich
          mitzuteilen, damit eine Nachbesserung erfolgen kann.
        </li>
        <li>Die Haftung für Folgeschäden wird ausgeschlossen.</li>
      </ol>

      {/* Abschnitt 7: Hinweise zu Allergenen und speziellen Ernährungsformen */}
      <h2>7. Allergene und besondere Ernährungsformen</h2>
      <ol>
        <li>Wir bieten sowohl vegetarische als auch vegane Speisen an.</li>
        <li>
          Allergene und Zusatzstoffe werden auf Nachfrage vom Servicepersonal
          oder in den Catering-Unterlagen mitgeteilt.
        </li>
        <li>
          Trotz sorgfältiger Zubereitung kann eine Kreuzkontamination nicht
          ausgeschlossen werden.
        </li>
      </ol>

      {/* Abschnitt 8: Datenschutzregelungen */}
      <h2>8. Datenschutz</h2>
      <ol>
        <li>
          Für die Abwicklung der Catering-Buchungen speichern wir
          personenbezogene Daten gemäß den Datenschutzbestimmungen.
        </li>
        <li>
          Die Daten werden nicht an Dritte weitergegeben, es sei denn, dies ist
          zur Vertragserfüllung erforderlich.
        </li>
      </ol>

      {/* Abschnitt 9: Schlussbestimmungen (Rechtswahl und Gerichtsstand) */}
      <h2>9. Schlussbestimmungen</h2>
      <ol>
        <li>Es gilt das Recht der Bundesrepublik Deutschland.</li>
        <li>Gerichtsstand für alle Streitigkeiten ist Mannheim.</li>
        <li>
          Sollte eine Klausel dieser AGB unwirksam sein, bleiben die übrigen
          Bestimmungen davon unberührt.
        </li>
      </ol>

      {/* Stand der AGB */}
      <p style={{ color: "#4B5563" }}>Stand: Juni 2025</p>
    </div>
  );
}

export default AGB;
